var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03d__03d__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#03d__03d__b)",
    fillRule: "evenodd",
    d: "M52.315 18.517l1.757-2.457-11.356 1.224L43.872 5.86l-9.248 6.732L30 2.12l-4.624 10.472L16.06 5.86l1.224 11.356L5.86 16.06l6.732 9.248L2.12 30l10.472 4.624L5.86 43.94l.57-.061c.369-.441.759-.868 1.17-1.279 3.5-3.6 8.1-5.7 13.1-6 2.7-3.9 7.2-6.2 12.1-6.2h1.1c4.363-6.14 11.011-10.453 18.415-11.883z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD348",
    fillRule: "evenodd",
    d: "M14.867 37.83A20.01 20.01 0 0120.7 36.6c2.7-3.9 7.2-6.2 12.1-6.2h1.1a29.679 29.679 0 0110.672-9.21c-4.775-7.863-15.023-10.525-23.082-5.956-7.87 4.565-10.725 14.6-6.623 22.597z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#03d__03d__c)",
    fillRule: "evenodd",
    d: "M17.565 37.034c1.022-.224 2.07-.37 3.135-.434 2.7-3.9 7.2-6.2 12.1-6.2h1.1a29.635 29.635 0 018.287-7.849c-4.026-6.562-12.633-8.81-19.328-4.927-6.765 3.923-9.155 12.626-5.294 19.41z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    fillRule: "evenodd",
    d: "M81.3 42.9C79.4 31.6 69.4 23 57.7 23c-9.1 0-17.3 5.1-21.3 13.1-1.2-.5-2.4-.7-3.6-.7-4.2 0-7.8 2.5-9.2 6.2-.6-.1-1.1-.1-1.7-.1-4.1 0-7.9 1.6-10.7 4.5C8.5 48.8 7 52.4 7 56.2v.2c.1 4.1 1.7 7.8 4.6 10.5 2.7 2.7 6.4 4.2 10.3 4.2h55.7c7.9 0 14.4-6.4 14.4-14.3 0-6.6-4.5-12.3-10.7-13.9z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#03d__03d__d)",
    fillRule: "evenodd",
    d: "M81.3 42.9C79.4 31.6 69.4 23 57.7 23c-9.1 0-17.3 5.1-21.3 13.1-1.2-.5-2.4-.7-3.6-.7-4.2 0-7.8 2.5-9.2 6.2-.6-.1-1.1-.1-1.7-.1-4.1 0-7.9 1.6-10.7 4.5C8.5 48.8 7 52.4 7 56.2v.2c.1 4.1 1.7 7.8 4.6 10.5 2.7 2.7 6.4 4.2 10.3 4.2h55.7c7.9 0 14.4-6.4 14.4-14.3 0-6.6-4.5-12.3-10.7-13.9z",
    clipRule: "evenodd",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#03d__03d__e)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B6B6",
    d: "M29.5 64c1.787 0 24.848-1.272 26.48-2 2.23-.994-2.39-6.972 0-7.47 1.08-.224 2.667-.927 2.667-.927s4.352-1.602 5.103-1.602c.75 0 .374-2.964.14-4.81l-.14-1.32c0-.87-2.592-2.674-3-4.87-.284-1.527.424-3.585.276-3.968 0 0-.05-.029-.036-.032.014-.004.026.007.036.032.112.053.922.327.922.327 1.948.66 5.03 1.74 7.802 3.64 1.658 1.138 3.941 3.314 3.941 3.314s1.645 1.272 2.059 1.687c1 1 4 4 6 4h5L89 51.59l.5 3.21c0 7.9-6.5 14.3-14.4 14.3H18.5S23 64 29.5 64z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "03d__03d__c",
    x1: 20.817,
    x2: 39.177,
    y1: 19.057,
    y2: 40.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F09900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "03d__03d__d",
    x1: 47.5,
    x2: 49.5,
    y1: 38.5,
    y2: 71.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B2B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "03d__03d__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(30 30) scale(27.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#D6B849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#FFCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03d__03d__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "03d__03d__e",
    width: 85,
    height: 46.101,
    x: 11.5,
    y: 30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_149_1385",
    stdDeviation: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudy);
export default __webpack_public_path__ + "static/media/partly_cloudy.fe01b3064976fa7891852a3f03036e4e.svg";
export { ForwardRef as ReactComponent };